import styled from "@emotion/styled";

import {
  Alert,
  DesignToken,
  NumericInput,
  ShadowToken,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { StyledLink } from "components/links/StyledLink";
import { ISubscription } from "store/entities/subscriptions";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

export interface IProps {
  nonViewersCount: number;
  newSubscription: ISubscription;
  onSeatsChange(seats: number): void;
}

export const AgentsRow = ({ nonViewersCount, newSubscription, onSeatsChange }: IProps): JSX.Element => {
  const agentsValue = newSubscription.agents === 0 ? "" : `${newSubscription.agents}`;
  const agentsToRemove = Math.max(0, nonViewersCount - newSubscription.agents);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSeatsChange = (seats: string) => {
    const parsedSeats = Number(seats.replace(/[^0-9]/g, "")) || 0;
    onSeatsChange(parsedSeats);
  };

  return (
    <Container>
      <Flex gap={withVar(SpacingToken.Spacing6)}>
        <Flex column gap={withVar(SpacingToken.Spacing2)}>
          <Text bold>Total paid users</Text>
          <Text size="sm" customColor={withVar(DesignToken.ContentBasicSecondary)}>
            The maximum number of paid users you can invite with this subscription plan.
          </Text>
        </Flex>
        <AgentsNumericInput
          value={agentsValue}
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={(seats: any) => handleSeatsChange(seats as string)}
          min={1}
          max={999}
          data-testid="agent-count-input"
        />
      </Flex>

      {agentsToRemove > 0 && (
        <Alert>
          <StyledLink to="/agents">
            Change {agentsToRemove} {plural(agentsToRemove, "Agent to Viewer", "Agents to Viewers")}
          </StyledLink>{" "}
          to update your subscription.
        </Alert>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${withVar(SpacingToken.Spacing4)};
  padding-bottom: ${withVar(SpacingToken.Spacing4)};
  box-shadow: ${withVar(ShadowToken.DividerBottom)};
`;

const AgentsNumericInput = styled(NumericInput)`
  width: 54px;
  input {
    width: 54px;
  }
`;
